import React, { useEffect, useState } from "react";
import Modal from "../ui/Modal";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { FaSearch } from "react-icons/fa";
const FilterSeguimientoClienteDialog = ({ open, setOpen, setFilterForms, setClient }) => {
  const [searchInputClientes, setSearchInputClientes] = useState("");
  const [allClientesUserList, setAllClientesUserList] = useState([]);

  const getInitialClientesWithQuery = async () => {
    await axios
      .get(
        `${BACKEND}/api/clientesUser?where[nombreComercial][like]=${searchInputClientes}`
      )
      .then(({ data }) => setAllClientesUserList(data.docs))
      .catch((e) => console.log(e));
  };

  const getSubmitClientes = async (event) => {
    event.preventDefault();
    await getInitialClientesWithQuery();
  };

  useEffect(() => {
    getInitialClientesWithQuery();
  }, []);

  return (
    <Modal activeModal={open} title={"Buscar cliente"} centered onClose={() => setOpen(false)}>
      <div>
        <form onSubmit={getSubmitClientes} className="mx-auto">
          <h3 className="text-gray-800 text-xs text-base mb-4 font-semibold">
            Seleccionar un cliente
          </h3>

          <div className="mb-4 mx-auto w-full">
            <label
              htmlFor="default-search"
              className="mb-2 text-xs font-medium sr-only text-gray-700"
            >
              Search
            </label>
            <div className="relative w-full">
              <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                <FaSearch className=" text-gray-600" />
              </div>
              <input
                type="search"
                id="default-search"
                value={searchInputClientes}
                onChange={(e) => setSearchInputClientes(e.target.value)}
                className="block w-full p-4 ps-10 text-xs  border 0 rounded-lg   bg-gray-100 border-gray-300 placeholder-gray-700 text-black "
                placeholder="Buscar clientes "
              />
              <button
                type="button"
                onClick={getSubmitClientes}
                className="text-white absolute end-2.5 bottom-2.5  focus:ring-4 focus:outline-none font-medium rounded-lg text-xs px-4 py-2 bg-blue-600 hover:bg-blue-700 focus:ring-blue-800"
              >
                Buscar
              </button>
            </div>
          </div>
        </form>

        <div className=" w-full   grid grid-cols-1 gap-2 md:grid-cols-2">
          {allClientesUserList.map((e) => (
            <button
              onClick={(ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                setClient ? setClient(e) : setFilterForms((prev) => ({ ...prev, cliente: e }));
                setOpen(false);
              }}
              type="button"
              className={`p-2 flex flex-col justify-start rounded-md  bg-gray-50 shadow-sm text-gray-700 hover:bg-blue-50 `}
              key={e.id}
            >
              <span className="text-xs text-base font-semibold ">
                {" "}
                {e.nombreComercial}
              </span>
              <span className=" text-xs font-light "> {e.email}</span>
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default FilterSeguimientoClienteDialog;
